
/* eslint no-unused-vars: 0 */
import ifDefined from '@ui5/webcomponents-base/dist/renderer/ifDefined.js';
import { html, svg, repeat, classMap, styleMap, unsafeHTML, setTags, setSuffix } from '@ui5/webcomponents-base/dist/renderer/LitRenderer.js';
const block0 = (context) => { return html`<div class="ui5-yp-root" role="grid" aria-readonly="false" aria-multiselectable="false" style="${styleMap(context.styles.main)}" @keydown=${context._onkeydown} @mousedown=${context._onmousedown} @mouseup=${context._onmouseup}>${ repeat(context._yearIntervals, (item, index) => item._id || index, (item, index) => block1(item, index, context)) }</div>`; };
const block1 = (item, index, context) => { return html`<div class="ui5-yp-interval-container">${ repeat(item, (item, index) => item._id || index, (item, index) => block2(item, index, context)) }</div>`; };
const block2 = (item, index, context) => { return html`<div id="${ifDefined(item.id)}" tabindex="${ifDefined(item._tabIndex)}" data-sap-timestamp="${ifDefined(item.timestamp)}" class="${ifDefined(item.classes)}" role="gridcell" aria-selected="false">${ifDefined(item.year)}</div>`; };


const main = (context, tags, suffix) => {
	setTags(tags);
	setSuffix(suffix);
	return block0(context);
};
 
export default main;